export const WIDGET_STATUS = {
  DRAFT: "draft",
  ACTIVE: "active",
  CLOSED: "closed",
};

export const STATUS_META = {
  [WIDGET_STATUS.DRAFT]: { color: "default", labelKey: "voiceCaptureManagement.status_draft" },
  [WIDGET_STATUS.ACTIVE]: { color: "success", labelKey: "voiceCaptureManagement.status_active" },
  [WIDGET_STATUS.CLOSED]: { color: "error", labelKey: "voiceCaptureManagement.status_closed" },
};

export const STATUS_FILTERS = [
  { key: "all", labelKey: "voiceCaptureManagement.status_all" },
  { key: WIDGET_STATUS.DRAFT, labelKey: "voiceCaptureManagement.status_draft" },
  { key: WIDGET_STATUS.ACTIVE, labelKey: "voiceCaptureManagement.status_active" },
  { key: WIDGET_STATUS.CLOSED, labelKey: "voiceCaptureManagement.status_closed" },
];

export const CAPTURE_MODES = {
  VOICE: "voice",
  TEXT: "text",
  VIDEO: "video",
};

export const MODE_META = {
  [CAPTURE_MODES.VOICE]: { labelKey: "voiceCaptureManagement.mode_voice" },
  [CAPTURE_MODES.TEXT]: { labelKey: "voiceCaptureManagement.mode_text" },
  [CAPTURE_MODES.VIDEO]: { labelKey: "voiceCaptureManagement.mode_video", disabled: true },
};

export const DISPLAY_MODES = [
  { value: "popup", labelKey: "voiceCaptureManagement.display_popup" },
  { value: "fullscreen", labelKey: "voiceCaptureManagement.display_fullscreen" },
  { value: "inline", labelKey: "voiceCaptureManagement.display_inline" },
];

export const CHANNEL_TYPES = {
  LINK_QR: "link_qr",
  WEB_EMBED: "web_embed",
};
